import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "@/v2-status-client/sentry"
import "@/v2-ui/css/index.css"
import "@/v2-ui/css/utilities.css"
import StatusPage from "@/v2-status-client/status/StatusPage"
import "@/v2-status-client/styles.css"

// The page lives in the v2-ui dark theme (gray-900 backgrounds,
// neutral-200 text). We toggle it on the <html> element on boot
// rather than letting it follow OS preference because this is a
// public status surface where we want a consistent look across
// every customer monitor / projector.
document.documentElement.classList.add("dark")

const el = document.querySelector<HTMLDivElement>("#root")
if (el) {
  const root = createRoot(el)
  root.render(
    <StrictMode>
      <StatusPage />
    </StrictMode>,
  )
}
